const redirectSignIn = process.env.REDIRECT_SIGN_IN
const redirectSignOut = process.env.REDIRECT_SIGN_OUT

export default {
  Auth: {
    // Amplify v6 ResourcesConfig-style manual configuration for Cognito User Pools + OAuth
    Cognito: {
      loginWith: {
        // This app signs in with a username
        email: false,
        oauth: {
          domain: process.env.OAUTH_DOMAIN,
          redirectSignIn: redirectSignIn ? [redirectSignIn] : [],
          redirectSignOut: redirectSignOut ? [redirectSignOut] : [],
          responseType: 'code',
          scopes: ['email', 'openid', 'profile'],
        },
        phone: false,
        username: true,
      },
      region: process.env.AWS_REGION,
      userPoolClientId: process.env.USER_POOL_WEB_CLIENT_ID,
      userPoolId: process.env.USER_POOL_ID,
    },
  },
}
